export const commonConfig = {
  darkTheme: true,
  classicHeader: true,
  bgImage: true,
};
